import React, { useEffect, useRef, useState } from "react";
import {
  DownloadIcon,
  FilterIcon,
  FilterUpdateIcon,
  SearchIcon,
} from "../../../../assets/images/svg/svg";
import {
  renderLength,
  renderCustomTabStatus,
} from "../../../../Utils/CommonUtils";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setPaginationTotalCount,
  setTableTabs,
} from "../../../../slices/common/reducer";
import { statusKeys } from "../../../../Utils/TableUtils";
import {
  PaddingLG,
  PaddingMD,
  PaddingSM,
} from "../../Tables/Tanstack/assets/svg";
import ColumnHidingDropdown from "./Components/ColumnHidingDropdown";
// import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";

const ComponentTabs = ({
  activeTab,
  activeTabName,
  setActiveTab,
  data,
  tabData,
  apiTabData, // apiTabData is used for dynamic tabs from server
  filterToggle,
  filterShow,
  onTabChange,
  search,
  hideTabs,
  hideTabsWrapper,
  hideTabsButtons,
  table,
  tableOptions = {},
  featuresOptions = {},
  download,
  handleDownload,
}) => {
  const [tabDataLengths, setTabDataLengths] = useState({});
  const isInitialRender = useRef(true);

  const triggerRender = useSelector((state) => state.common.triggerRender);
  const sidebarView = useSelector((state) => state.common.sidebar.view);
  const downloadLoading = useSelector((state) => state.common.loader.download);

  const dispatch = useDispatch();

  const { enableColumnPadding, enableColumnHiding } = featuresOptions;
  const { paddingIndex, setPaddingIndex } = tableOptions;

  useEffect(() => {
    dispatch(setActiveTab(activeTabName)); // outer listings will have ALL

    if (apiTabData && activeTab === "ALL") {
      const ALLObject = apiTabData?.find((item) => item?.tab_value === "ALL");
      dispatch(setPaginationTotalCount(ALLObject?.tab_value_count));
    }

    if (isInitialRender.current) {
      dispatch(setTableTabs([]));
      isInitialRender.current = false;
      return;
    }

    // Call the onTabChange function when the tab changes
    if (onTabChange && !isInitialRender.current) {
      onTabChange(activeTab);
    }

    // Don't add data, activeTab
  }, [apiTabData, triggerRender]);

  useEffect(() => {
    if (tabData) {
      const newTabDataLengths = {};

      tabData.forEach((tab) => {
        newTabDataLengths[tab?.value] = data?.filter((item) => {
          if (tab?.value === "ALL") {
            return true;
          }
          return statusKeys.some((key) => item[key] === tab?.value);
        }).length;
      });

      setTabDataLengths(newTabDataLengths);
    }
  }, [data, tabData]);

  const handleTabChange = (tab) => {
    if (tab?.tab_value === activeTab) {
      return;
    }
    dispatch(setActiveTab(tab?.tab_value));

    if (apiTabData) {
      dispatch(setPaginationTotalCount(tab?.tab_value_count));

      if (onTabChange) {
        onTabChange(tab?.tab_value);
      }
    }
  };

  return (
    !hideTabsWrapper && (
      <div className="main-tab-wrapper">
        <div className="top-container">
          {!hideTabs && (
            <div
              className={`tab-wrapper-class ${
                sidebarView ? "sidebar-open" : "sidebar-closed"
              }`}
            >
              {apiTabData
                ? Array?.isArray(apiTabData) &&
                  [...apiTabData]
                    ?.sort((a, b) => a?.tab_position - b?.tab_position)
                    ?.map(
                      (tab) =>
                        tab?.tab_value != null && (
                          <div
                            className={`content-tab ${
                              activeTab === tab?.tab_value ? "active" : ""
                            }`}
                            key={tab?.tab_value}
                            onClick={() => handleTabChange(tab)}
                          >
                            <div className="content-tab-text">
                              <span className="tab-text">
                                {renderCustomTabStatus(
                                  tab?.tab_value?.slice(0, 1)?.toUpperCase() +
                                    tab?.tab_value?.slice(1)?.toLowerCase()
                                )}
                              </span>

                              <span className="tab-quantity">
                                {renderLength(
                                  activeTab === tab?.tab_value
                                    ? "active"
                                    : "inactive",
                                  tab?.tab_value_count || 0
                                )}
                              </span>
                            </div>
                          </div>
                        )
                    )
                : tabData?.map((tab) => (
                    <div
                      className={`content-tab ${
                        activeTab === tab?.value ? "active" : ""
                      }`}
                      key={tab?.label}
                      onClick={() => dispatch(setActiveTab(tab?.value))}
                    >
                      <div className="content-tab-text">
                        <span className="tab-text">{tab?.label}</span>
                        <span className="tab-quantity">
                          {renderLength(
                            activeTab === tab?.value ? "active" : "inactive",
                            tabDataLengths[tab?.value] || 0
                          )}
                        </span>
                      </div>
                    </div>
                  ))}
            </div>
          )}
        </div>
        {!hideTabsButtons && (
          <div className="rightside-contain">
            {search && (
              <div className="search-wrapper">
                <SearchIcon />
                <input
                  className="search-fields"
                  type="text"
                  placeholder="Search"
                  // value={searchQuery}
                  // onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            )}

            {download &&
              (downloadLoading ? (
                // <LoadingSpinner
                //   className={"mini-loader"}
                //   loaderSize={"16"}
                //   loaderColor={"#1d1d1d"}
                //   miniLoader
                // />
                <div>Loading...</div>
              ) : (
                <span
                  className="hover-icon"
                  title="Download"
                  style={{ padding: "4px", cursor: "pointer" }}
                  onClick={handleDownload && handleDownload}
                >
                  <DownloadIcon />
                </span>
              ))}

            {filterToggle && (
              <span
                className="right-side-btn hover-icon"
                onClick={filterToggle}
              >
                {filterShow ? <FilterUpdateIcon /> : <FilterIcon />}
              </span>
            )}

            {enableColumnHiding && <ColumnHidingDropdown table={table} />}

            {enableColumnPadding && (
              <button
                onClick={setPaddingIndex}
                className="ts__topbar__button ts__topbar__filter"
              >
                {paddingIndex === 0 && <PaddingSM />}
                {paddingIndex === 1 && <PaddingMD />}
                {paddingIndex !== 0 && paddingIndex !== 1 && <PaddingLG />}
              </button>
            )}
          </div>
        )}
      </div>
    )
  );
};

export default ComponentTabs;
